import './App.css';
import Weather from './Weather'

function App() {
  return (
    <div className="App">
      <Weather/>
    </div>
  );
}

export default App;
